import { DiagramBpmn } from "alurkerja-ui";
import { BpmnInterface } from "alurkerja-ui/dist/components/Bpmn/Diagram";
import { DefaultButton } from "./button";
import { useEffect, useState } from "react";
import { LucideWorkflow } from "lucide-react";
import { axiosInstance } from "@/utils/lib/axios";

interface BpmnProps extends BpmnInterface {
  businessKey?: string;
}
export function Bpmn({ url, businessKey }: BpmnProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [isIntercepted, setIsIntercepted] = useState(false);

  useEffect(() => {
    const statisticRequestInterceptor = axiosInstance.interceptors.request.use(
      (config) => {
        if (!config.url?.includes(url + "/statistic")) {
          return config;
        }
        if (!businessKey) {
          return config;
        }

        config.url = `${url}/statistic?businessKeys=${businessKey}`;
        return config;
      },
    );

    const businessKeyUrl = url + "/statistic?businessKeys=" + businessKey;
    const statisticResponseInterceptor =
      axiosInstance.interceptors.response.use(
        (response) => {
          if (response.config.url?.includes(businessKeyUrl)) {
            const tasks = response.data?.data?.tasks ?? {};
            for (const key in tasks) {
              if (tasks[key] === 0) {
                delete tasks[key];
              }
            }
          }

          return response;
        },
        (error: Error) => {
          return Promise.reject(error);
        },
      );

    setIsIntercepted(true);

    return () => {
      axiosInstance.interceptors.request.eject(statisticRequestInterceptor);
      axiosInstance.interceptors.response.eject(statisticResponseInterceptor);
      setIsIntercepted(false);
    };
  }, [businessKey, url]);

  function handleClick() {
    setIsOpen(!isOpen);
  }

  return (
    <div className="space-y-2">
      <DefaultButton
        mood="axiata-blue-outline"
        onClick={handleClick}
        className="flex items-center justify-center"
      >
        <LucideWorkflow />
        <span className="sr-only">BPMN</span>
      </DefaultButton>
      {isOpen && isIntercepted && (
        <div className="border bg-white">
          <DiagramBpmn url={url} counterMode="" />
        </div>
      )}
    </div>
  );
}
